import { produce } from 'immer';
import { extractError } from 'app/lib/error';
import { toStringFqn } from 'app/lib/utils';
import type { DbtModelInfo, GetDbtModelInfoFailure } from 'app/lib/types/server';
import type { TypedReduxActionOutcomes } from 'app/store/storeTypes';
import { GET_DBT_MODEL_INFO_ACTION_TYPE } from './types';

export type DbtStateSlice = {
    modelInfoByFqn: Record<string, DbtModelInfo>;
    isLoading: boolean;
    error: null | GetDbtModelInfoFailure;
};

export const INITIAL_STATE: DbtStateSlice = {
    modelInfoByFqn: {},
    isLoading: false,
    error: null
};

export const dbtReducer = produce((draft, action: TypedReduxActionOutcomes) => {
    switch (action.type) {
        case GET_DBT_MODEL_INFO_ACTION_TYPE.STARTED: {
            draft.error = null;
            draft.isLoading = true;
            break;
        }
        case GET_DBT_MODEL_INFO_ACTION_TYPE.SUCCEEDED: {
            draft.modelInfoByFqn[toStringFqn(action.payload)] = action.payload;
            return;
        }
        case GET_DBT_MODEL_INFO_ACTION_TYPE.FAILED: {
            draft.error = extractError(action.payload);
            break;
        }
        case GET_DBT_MODEL_INFO_ACTION_TYPE.ENDED: {
            draft.isLoading = false;
            break;
        }

        default:
    }
}, INITIAL_STATE);
